<template>
  <div class="col-12 col-sm-6 col-xl-4 mb-3 px-2">
    <div :class="'card border-0 shadow-sm product ' + (product.listing.is_purchasable ? 'purchasable' : 'not-purchasable')">
      <div class="text-center">
        <img class="img-fluid" :src="cdnUrl + product.listing.image.small">
      </div>
      <div class="card-body py-2">
        <h6><a target="_blank" :href="websiteUrl + product.listing.url">{{ product.listing.name }}</a></h6>
        <p class="mb-1">
          <span class="d-inline-block price mr-2" v-if="variant ? variant.selling_price : product.listing.pricing.selling_price">{{ variant ? variant.selling_price : product.listing.pricing.selling_price | numberToRs }}</span>
          <span v-if="regularPrice" class="d-inline-block regular-price small text-muted">{{ regularPrice | numberToRs }}</span>
        </p>
        <p class="mb-0">
          <span class="text-muted">Availability:</span> {{ product.listing.stock_status.text }}
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <form v-if="product.listing.is_purchasable" @submit.prevent="$parent.addToCart(product.listing.id, variant.id, variant.variant_merchant_id, quantity)">
          <div class="form-row mb-3" v-if="product.details.variants.length>1">
            <div class="col">
              <select class="form-control" v-model="variant" :disabled="$parent.processing_add_to_cart" required>
                <option v-for="(value, key) in product.details.variants" :key="key" :value="value" :disabled="!value.is_purchasable">{{ value.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row mb-2">
            <div class="col-md-4">
              <input type="number" class="form-control text-center" v-model="quantity" min="1" :disabled="$parent.processing_add_to_cart" required>
            </div>
            <div class="col-md-8">
              <button type="submit" class="btn btn-block btn-outline-primary" :disabled="$parent.processing_add_to_cart">
                <i class="fas fa-circle-notch fa-spin" v-if="$parent.processing_add_to_cart"></i>
                <i class="fa fa-plus" v-if="!$parent.processing_add_to_cart"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaleSearchProductResult',
  props: [
    'product'
  ],
  computed: {
    websiteUrl () {
      return this.$store.state.store ? this.$store.state.store.urls.website : '#'
    },
    regularPrice () {
      return this.variant ? this.variant.regular_price : this.product.listing.pricing.regular_price
    }
  },
  data () {
    return {
      cdnUrl: this.$store.state.store.urls.cdn,
      variant: null,
      quantity: 1
    }
  },
  mounted () {
    if (this.product.details.variants.length === 1) {
      this.variant = this.product.details.variants[0]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sale/partials/SearchProductResult.vue